import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { MeetingErrorLayout } from 'modules/meetings/components/Layout/MeetingErrorLayout'
import { MeetingTranscriptProvider } from 'modules/meetings/lib/context/MeetingTranscriptContext/MeetingTranscriptProvider'
import { MeetingsMeetingProvider } from 'modules/meetings/lib/context/MeetingsMeetingContext/MeetingsMeetingProvider'
import { useMeeting } from 'modules/meetings/lib/hooks/useMeeting'

const OneOnOnesMeetingWrapperPageContent = () => {
  const { meetingId } = useParams<{ meetingId: string }>()
  const { setMeetingId, error } = useMeeting()

  useEffect(() => {
    if (meetingId) setMeetingId(Number(meetingId))
  }, [meetingId, setMeetingId])

  if (error) {
    return <MeetingErrorLayout />
  }

  return (
    <MeetingTranscriptProvider>
      <Outlet />
    </MeetingTranscriptProvider>
  )
}

function OneOnOnesMeetingWrapperPage() {
  return (
    <MeetingsMeetingProvider>
      <OneOnOnesMeetingWrapperPageContent />
    </MeetingsMeetingProvider>
  )
}
export default OneOnOnesMeetingWrapperPage
